// project hash key
// e921d896b24ee51ad95dc303a034758da1187532b0a44189bd99aa333255781b

import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import TButton from '../../../common/button';
import wChange from '../../../../../assets/imgs/lotteryDetail/wChange.png';
import RainbowText from '../../../common/rainbowText';
import './index.scss';
import PrizeItem from './PrizeItem';
import RecommendLottery from './RecommendLottery';
import { useHistory } from 'react-router-dom';
import OnChallengeText from '../../../common/OnChallengeText';
import PreviewPhoto from '../../purchaseHistoryDetail/PurchaseHistoryDetailPC/PreviewPhoto';
import { ON_CHALLENGE } from '../../../../constants';
import {
  facebookIcon,
  GUIDE,
  TOP_IMAGES,
  twitterIcon,
  lineIcon,
  iconBeside,
  iconBox,
  recommendPC,
  dotted,
} from '../../../../../assets/imgs';

export const StyledTitle = styled.div`
  background-size: cover;
`;

const Line = styled.div`
  background-image: url(${TOP_IMAGES.LineShort});
  height: 6px;
  width: 163px;
  margin: 0 auto;
  margin-bottom: 55px;
`;

export default function ScratchResultPC(props) {
  const history = useHistory();
  const {
    scratchResult,
    recommendLottery,
    gotoReBuy,
    gotoLotteryDetail,
    totalPrize,
    handleShare,
    getWidth,
    isQuantityWChance,
  } = props;

  const __prizeNormalData =
    scratchResult && scratchResult.filter((item) => item.rank_name !== ON_CHALLENGE);

  const __wChanceData =
    scratchResult && scratchResult.find((item) => item.rank_name === ON_CHALLENGE);

  const [isShowReview, setShowReview] = useState(false);
  const [selectedPrize, setSelectedPrize] = useState(null);

  const eleWrap = document?.getElementById('share-sns-wrapper')?.offsetWidth;

  const [width, setWidth] = useState(eleWrap);
  useEffect(() => {
    setWidth(eleWrap);
  }, [eleWrap]);
  useEffect(() => {
    if (width) {
      getWidth(width);
    }
  }, [width]);
  useEffect(() => {
    function handleResize() {
      setWidth(document.getElementById('share-sns-wrapper')?.offsetWidth);
    }

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const pathLotteryTrial = '/result/trial';
  const pathSite = history.location.pathname;

  return (
    <>
      <div className="main-content resultPC">
        <div id="share-sns-wrapper">
          {__prizeNormalData && (
            <div className="list-prize-wrapper d-flex flex-wrap">
              {__prizeNormalData.map((item, index) => (
                <PrizeItem
                  data={item}
                  key={index}
                  onClick={() => {
                    setShowReview(true);
                    setSelectedPrize(item);
                  }}
                />
              ))}
            </div>
          )}

          {__wChanceData && (
            <div
              className="wChance-wrapper"
              style={{ marginBottom: pathLotteryTrial === pathSite ? '180px' : 'unset' }}
            >
              <div
                className="wchance-all"
                style={{
                  backgroundColor:
                    (pathLotteryTrial === pathSite && isQuantityWChance === 0) ||
                    (pathLotteryTrial !== pathSite && !__wChanceData?.quantity)
                      ? 'rgba(120,120,120,0.4)'
                      : '',
                }}
              >
                <div className="wchance-full">
                  <StyledTitle className="title AOTFShinMaruGoPro">
                    <OnChallengeText isInResult />
                  </StyledTitle>
                  <div className="wchance-content">
                    <PrizeItem
                      data={__wChanceData}
                      type={ON_CHALLENGE}
                      totalPrize={totalPrize}
                      onClick={() => {
                        setShowReview(true);
                        setSelectedPrize(__wChanceData);
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>

        <PreviewPhoto
          show={isShowReview}
          onHide={() => setShowReview(false)}
          data={selectedPrize}
          isInResultPage
        />

        {pathLotteryTrial !== pathSite && (
          <div className="text-center list-icon">
            <TButton
              title="もう一度購入する"
              className="reBuy tertiary has-long-text NotoSansJP"
              onClick={gotoReBuy}
            />
            <div className="button-collection">
              <TButton
                title="MYコレクションを見る"
                className="btnCollection collection primary has-long-text NotoSansJP"
                onClick={() => history.push('/my-collection')}
              />
              <img src={iconBox} alt="icon" className="icon" />
            </div>
            <TButton
              title="商品ページへ戻る"
              className="goBack secondary has-long-text NotoSansJP btnGoBack"
              onClick={gotoLotteryDetail}
            />
          </div>
        )}

        {pathLotteryTrial !== pathSite && (
          <div className="share-sns">
            <div className="title">
              <img src={iconBeside} alt="icon" className="icon" />
              <div className="text-share NotoSansJP my-color-black-400">結果をシェアする</div>
              <img src={iconBeside} alt="icon" className="icon" />
            </div>
            <div className="icon-wrapper">
              <img
                src={facebookIcon}
                alt="icon"
                className="icon icon-margin"
                onClick={() => handleShare('fb')}
              />
              <img
                src={twitterIcon}
                alt="icon"
                className="icon"
                onClick={() => handleShare('tw')}
              />
            </div>
          </div>
        )}

        {pathLotteryTrial === pathSite && (
          <div className="text-center">
            <div
              className="d-flex justify-content-center main-content NotoSansJP500"
              style={{ marginBottom: 40 }}
            >
              <TButton
                id="goBack"
                title="もう一度お試しクジする"
                className="secondary has-long-text NotoSansJP500"
                onClick={() => history.push('/purchase/trial')}
              />
              <TButton
                title="商品ページへ戻る"
                className="primary has-long-text NotoSansJP500"
                onClick={() => history.push('/trial')}
              />
            </div>
          </div>
        )}
      </div>

      {recommendLottery.length ? (
        <div>
          <div
            className="border-dots"
            style={{
              backgroundImage: `url(${dotted})`,
              backgroundSize: '1200px',
              backgroundRepeatY: 'no-repeat',
              height: '1vh',
              paddingBottom: '15px',
            }}
          ></div>
          <div className="recommend-lottery-wrapper border-top-dots">
            <div style={{ marginBottom: 56 }} className="text-center">
              <img src={recommendPC} />
            </div>
            <div>
              <RecommendLottery recommendLottery={recommendLottery} />
            </div>
          </div>
        </div>
      ) : null}
    </>
  );
}
